<template>
    <v-app-bar color="white" app dense elevate-on-scroll clipped-left>
        <v-app-bar-nav-icon v-if="!isLogin"  @click="$store.commit('application/setDisplayMobileDrawer', true)"></v-app-bar-nav-icon>
        <v-toolbar-items>
            <router-link :to="logoPath">
                <v-img class="ml-auto" :src="getConfig('logo_url', '')" :max-width="logoWidth" contain height="50" />
            </router-link>
        </v-toolbar-items>

        <v-spacer />

        <UserProfile v-if="$store.state.application.isConnected" />
    </v-app-bar>
</template>

<script>
import UserProfile from './UserProfile';

export default {
    name: 'AppBarMobile',

    data: () => ({
        displayDrawer: false
    }),

    components: {
        UserProfile
    },

    computed: {
        isLogin() {
            return this.$route.path.includes('/connexion');
        },
        logoPath() {
            if (this.$store.state.application.user) {
                if (this.getConfig('messages.enabled', true)) {
                    return this.$store.state.application.user.type === 'buyer' ? '/' : '/messages';
                } else {
                    return this.$store.state.application.user.type === 'buyer' ? '/' : '/actualites';
                }
            }
            return '';
        },
        unreadMessagesCount() {
            const count = this.$store.state.application.unreadMessagesCount;
            if (typeof count === 'number' && !isNaN(count)) {
                if (count > 99) {
                    return '+99';
                } else {
                    return count;
                }
            } else {
                return 0;
            }
        },
        logoWidth() {
            return this.getConfig('logo_width_mobile', '');
        }
    }
};
</script>

<style lang="scss" scoped>
.no-padding-left::v-deep {
    .v-toolbar__content {
        padding-left: 0;
    }
}
</style>